import { Button } from "@mui/material";
import React from "react";

const NoSchedule = (props) => {
  const {haveInterestBonus} = props;
  return (
    <div className="text-center min-h-[250px] flex flex-col items-center justify-center p-[25px_15px]">
      <h1 className="text-[#333333] text-[17px] mb-[8px] font-[700]">
        You don’t have any dealer commission schedules
      </h1>
      <p className="text-[#5F7585] text-[14px] font-[500] mb-[17px]">Seems like you don’t have any Schedule</p>
      {
        haveInterestBonus ? 
        <Button type="button" className="sav_btn" onClick={()=>props.editOpt()}>Schedule Now</Button> :
        <Button type="button" className="sav_btn" onClick={()=>props.changeToCurrent()}>Add Dealer Commission</Button>
      }
    </div>
  )
};

export default NoSchedule;
